// Scoped styles for a view mounted in a host. Inside a ShadowRoot, or directly in the document,
// they go in a constructable stylesheet, which a strict Content-Security-Policy allows (no inline
// styles; the desktop app's settings window); elsewhere a <style> element next to the view keeps
// them, with the host's nonce if it has one.
// Returns a function that takes them away again.
export function addStyles(root, css, { nonce } = {}) {
  const scope = root.getRootNode?.() ?? root;
  const adopts = (typeof ShadowRoot === 'function' && scope instanceof ShadowRoot)
    || (typeof Document === 'function' && scope instanceof Document);
  if (adopts && 'adoptedStyleSheets' in scope) {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(css);
    scope.adoptedStyleSheets = [...scope.adoptedStyleSheets, sheet];
    return () => { scope.adoptedStyleSheets = scope.adoptedStyleSheets.filter(s => s !== sheet); };
  }
  const style = document.createElement('style');
  if (nonce) style.nonce = nonce;
  style.textContent = css;
  root.append(style);
  return () => style.remove();
}
